import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = control.value?.toString().trim() ?? '';

    if (!rawValue) return null;

    const digitsOnly = rawValue.replace(/[^0-9]/g, '');

    // Allow plain digit entry (7-12 digits) to support separate country code selection
    if (digitsOnly.length >= 7 && digitsOnly.length <= 12) {
      return null;
    }

    // Patterns by region (prefixed with +)
    const patterns = {
      india: /^\+91\d{10}$/,
      usa: /^\+1\d{10}$/,
      canada: /^\+1\d{10}$/,
      uk: /^\+44\d{9,10}$/,
      middleEast: /^\+(971|966|974|973|968|967|965|964|962|961)\d{7,9}$/
      // (971: UAE, 966: Saudi, 974: Qatar, 973: Bahrain, 968: Oman, etc.)
    };

    const isValid =
      patterns.india.test(rawValue) ||
      patterns.usa.test(rawValue) ||
      patterns.canada.test(rawValue) ||
      patterns.uk.test(rawValue) ||
      patterns.middleEast.test(rawValue);

    return isValid ? null : { invalidPhone: true };
  };
}